// extracted by mini-css-extract-plugin
module.exports = {"vanlife-B":"B_vanlife-B__YrxnC"};